import React from 'react';
import './index.css';
import ChatApp from './main';

function App() {
  return (
    <div>
      <ChatApp />
    </div>
  );
}

export default App;